module.exports = __webpack_public_path__ + "assets/img/Large_2.cc4b21a4.svg";